import { Observable } from 'rxjs';
import { ApiHelper } from '../apiHelper';
import { IBaseDAO } from './IBaseDAO';

export abstract class BaseDAO<T> implements IBaseDAO<T> {
  resource: string;

  protected constructor(
    public readonly apiHelper: ApiHelper,
    resource: string,
  ) {
    this.resource = resource;
  }

  public load(): Observable<T[]> {
    const url = this.apiHelper.getServiceName() + this.getResource() + '/';
    const method = 'GET';
    const headers = this.apiHelper.getDefaultHeader();
    return this.apiHelper.apiCall<T[]>(url, method, null, null, headers);
  }

  public loadById(id: any): Observable<T> {
    const url = `${this.apiHelper.getServiceName()}${this.getResource()}/${id}`;
    const method = 'GET';
    const headers = this.apiHelper.getDefaultHeader();
    return this.apiHelper.apiCall<T>(url, method, null, null, headers);
  }

  public get(): Observable<T[]> {
    const url = this.apiHelper.getServiceName() + this.getResource() + '/';
    const method = 'GET';
    const headers = this.apiHelper.getDefaultHeader();
    return this.apiHelper.apiCall<T[]>(url, method, null, null, headers);
  }

  public getById(id: any): Observable<T> {
    const url =
      this.apiHelper.getServiceName() + this.getResource() + '/' + id + '/';
    const method = 'GET';
    const headers = this.apiHelper.getDefaultHeader();
    return this.apiHelper.apiCall<T>(url, method, null, null, headers);
  }

  public create(initialVals: Object): Observable<T> {
    const url = this.apiHelper.getServiceName() + this.getResource() + '/';
    const method = 'POST';
    const headers = this.apiHelper.getDefaultHeader();
    return this.apiHelper.apiCall<T>(url, method, null, initialVals, headers);
  }

  public serverCreate(initialVals: Object): Observable<T> {
    return this.create(initialVals);
  }

  public serverUpdate(editVals): Observable<T> {
    const url =
      this.apiHelper.getServiceName() +
      this.getResource() +
      '/' +
      editVals.id +
      '/';
    const method = 'PUT';
    const headers = this.apiHelper.getDefaultHeader();
    return this.apiHelper.apiCall<T>(url, method, null, editVals, headers);
  }

  public serverDelete(itemToDelete): Observable<T> {
    const url =
      this.apiHelper.getServiceName() +
      this.getResource() +
      '/' +
      itemToDelete.id +
      '/';
    const method = 'DELETE';
    const headers = this.apiHelper.getDefaultHeader();
    return this.apiHelper.apiCall<T>(url, method, null, itemToDelete, headers);
  }

  public getResource(): string {
    return this.resource;
  }
}
